import React from 'react'
import { Box, Text, TextInput } from 'grommet'
import InputButton from '../Button/InputButton'
import { useSelector, useDispatch } from 'react-redux'
import {
  setDigitRanges,
  showTurntable,
  setDigitNumber,
} from '../../redux/rng/actions'
import { setStartRotate } from '../../redux/turntable/actions'
import styled from 'styled-components'

const NoWrapText = styled(Text)`
  white-space: nowrap;
`

const DigitInput = ({
  digitNumber,
  numberDigitChanged,
  digitRanges,
  boardIndex,
}) => {
  const digitArray = [2, 3, 4, 5, 6]
  const digitPosition = ['1st', '2nd', '3rd', '4th', '5th', '6th']
  // const { digitRanges, boardIndex } = useSelector(state => state.rng)
  const randomStart = useSelector(
    state => state.settings.spinBehavior.randomStart,
  )
  const dispatch = useDispatch()

  return (
    <Box margin={{ top: '0rem' }} gap=".5rem">
      <Text>Number of Digits: </Text>
      <Box direction="row-reverse" gap="1rem" justify="center">
        {digitArray.map(digit => {
          return (
            <InputButton
              key={`numberDigitInput${digit}`}
              active={digit === digitNumber}
              onClick={() => {
                dispatch(setDigitNumber(digit))
                numberDigitChanged(digit)
              }}
            >
              {digit}
            </InputButton>
          )
        })}
      </Box>
      <Box direction="row" width="100%" margin={{ top: '1rem' }}>
        <Box gap=".3rem" flex={{ grow: 1, shrink: 1 }}>
          <Box background="inputDarkLight" pad=".2rem">
            <NoWrapText color="invertText" textAlign="center">
              Num
            </NoWrapText>
          </Box>
          <Box pad={{ horizontal: '.5rem' }} align="end" gap=".3rem">
            <Box height="3rem" justify="center">
              <NoWrapText>From</NoWrapText>
            </Box>
            <Box height="3rem" justify="center">
              <NoWrapText>To</NoWrapText>
            </Box>
          </Box>
        </Box>
        <Box direction="row-reverse" flex={{ grow: 6, shrink: 6 }}>
          {digitPosition.map((position, index) => {
            const disabled = index + 1 > digitNumber
            return (
              <DigitRangeInput
                key={`digitPosition${position}`}
                position={position}
                range={digitRanges[index]}
                disabled={disabled}
                onChangeMin={event => {
                  const value = +event.target.value
                  const tempRanges = digitRanges.slice(0)
                  const tempCurrentRange = digitRanges[index].slice(0)
                  tempCurrentRange[0] = value
                  tempRanges[index] = tempCurrentRange
                  dispatch(setDigitRanges(tempRanges))
                  if (boardIndex === index) {
                    dispatch(showTurntable(null))
                    const startAngle = randomStart
                      ? 2 * Math.PI * Math.random()
                      : 0
                    dispatch(setStartRotate(startAngle))
                  }
                }}
                onChangeMax={event => {
                  const value = +event.target.value
                  const tempRanges = digitRanges.slice(0)
                  const tempCurrentRange = digitRanges[index].slice(0)
                  tempCurrentRange[1] = value
                  tempRanges[index] = tempCurrentRange
                  dispatch(setDigitRanges(tempRanges))
                  if (boardIndex === index) {
                    dispatch(showTurntable(null))
                    const startAngle = randomStart
                      ? 2 * Math.PI * Math.random()
                      : 0
                    dispatch(setStartRotate(startAngle))
                  }
                }}
                // active={digit === digitNumber}
                // onClick={() => dispatch(setDigitNumber(digit))}
              />
            )
          })}
        </Box>
      </Box>
    </Box>
  )
}

const DigitRangeInput = ({
  position,
  range,
  disabled,
  onChangeMin,
  onChangeMax,
}) => {
  return (
    <Box gap=".3rem" flex={true}>
      <Box background="inputDarkLight" pad=".2rem">
        <NoWrapText color="invertText" textAlign="center">
          {position}
        </NoWrapText>
      </Box>
      <Box pad={{ horizontal: '.5rem' }} gap=".3rem">
        <TextInput
          disabled={disabled}
          type="number"
          min={0}
          max={range[1]}
          value={range[0]}
          style={{ padding: '.2rem', textAlign: 'center' }}
          onChange={onChangeMin}
          onClick={e => e.target.select()}
        />
        <TextInput
          disabled={disabled}
          type="number"
          min={range[0]}
          max={9}
          value={range[1]}
          style={{ padding: '.2rem', textAlign: 'center' }}
          onChange={onChangeMax}
          onClick={e => e.target.select()}
        />
      </Box>
    </Box>
  )
}

export default DigitInput
